import React from 'react';
import './styles.css';

export const VotingClosed = () => {
  return (
    <div className="voting-closed-container">
      <div className="success-view">
        <div className="success-header">
          <h2>Voting closed</h2>
          <p className="success-subtitle">See you at Camp Flog Gnaw</p>
        </div>
      </div>
    </div>
  );
};

export default VotingClosed;
